import type { V4SubscriptionsFilters } from '../types';

export const subscriptionKeys = {
  all: ['subscriptions'] as const,
  lists: () => [...subscriptionKeys.all, 'list'] as const,
  list: (filters?: V4SubscriptionsFilters) => [...subscriptionKeys.lists(), filters] as const,
  details: () => [...subscriptionKeys.all, 'detail'] as const,
  detail: (id: string) => [...subscriptionKeys.details(), id] as const,
  invoices: (subscriptionId: string) => [...subscriptionKeys.all, 'invoices', subscriptionId] as const,
  sensors: (subscriptionNumber: string) => [...subscriptionKeys.all, 'sensors', subscriptionNumber] as const,
  accounts: (search?: string) => [...subscriptionKeys.all, 'accounts', search] as const,
  salesUsers: () => [...subscriptionKeys.all, 'salesUsers'] as const,
  contractualManagers: (accountId: string) => [...subscriptionKeys.all, 'contractualManagers', accountId] as const,
  technicalManagers: (accountId: string) => [...subscriptionKeys.all, 'technicalManagers', accountId] as const,
  quotes: (subscriptionId: string) => [...subscriptionKeys.all, 'quotes', subscriptionId] as const,
  renewalSummary: (subscriptionId: string) => [...subscriptionKeys.all, 'renewalSummary', subscriptionId] as const,
  reconciliation: (subscriptionId: string) => [...subscriptionKeys.all, 'reconciliation', subscriptionId] as const,
  portfolioTotals: () => [...subscriptionKeys.all, 'portfolioTotals'] as const,
  revenueByMonth: (from: string, to: string, salesManagerId?: string) => [...subscriptionKeys.all, 'revenueByMonth', from, to, salesManagerId ?? 'all'] as const,
  renewalQuotePreview: (subscriptionId: string) => [...subscriptionKeys.all, 'renewalQuotePreview', subscriptionId] as const,
  invoiceSearch: (accountId: string, search?: string, page?: number) => [...subscriptionKeys.all, 'invoiceSearch', accountId, search, page] as const,
  quoteSearch: (accountId: string, search?: string, page?: number) => [...subscriptionKeys.all, 'quoteSearch', accountId, search, page] as const,
};

/** @deprecated Use subscriptionKeys */
export const contractKeys = subscriptionKeys;
